import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateDistrictResponseEntity } from '../../domain/entities/CreateDistrictResponseEntity'
import type { PostRegionDistrictsAdminResponse } from '@/backend/market'

export class CreateDistrictResponseModel extends CreateDistrictResponseEntity {
  constructor(dataDto: PostRegionDistrictsAdminResponse) {
    super()
    mapEntityProperties<CreateDistrictResponseEntity>(this, dataDto)
  }
}
